function bufferToString(buffer: BufferType) {
    return buffer?.data?.map((byte: number) => byte?.toString(16).padStart(2, '0'))?.join('');
}
export default bufferToString;
